export function isEmptyObject(obj) {
    return obj == null || Object.entries(obj).length === 0;
}